<template>
  <el-tabs v-model="activeName">
    <el-tab-pane
      v-for="(item, itemIdx) in config.categoryConfigs"
      :label="getLocaleText(item.title)"
      :name="item.title + itemIdx"
      :key="item.title + itemIdx"
    >
      <template #label>
        <div class="category-column">
          <img
            v-show="item.url && item.title + itemIdx !== activeName"
            class="category-item-icon"
            :key="`${itemIdx}-img`"
            :src="item.url"
            alt=""
          />
          <img
            v-show="item.activeUrl && item.title + itemIdx === activeName"
            class="category-item-icon active"
            :key="`${itemIdx}-img1`"
            :src="item.activeUrl"
            alt=""
          />
          <span class="category-item-title">{{ getLocaleText(item.title) }}</span>
        </div>
      </template>

      <element-item
        v-if="config.items[itemIdx]"
        :key="itemIdx"
        :disabled="!edit"
        :allArcListMap="getArcListMap(itemIdx)"
        :parentKeys="[...parentKeys, idx]"
        :item-data="config.items[itemIdx]"
        :currentElementIndex="currentElementIndex"
        :idx="itemIdx"
        :list-length="config.items.length"
      />
    </el-tab-pane>
  </el-tabs>
</template>
<script setup>
import { ref, reactive, watch, computed, onMounted, onBeforeUnmount } from 'vue';
import { useRoute } from 'vue-router';
import { useElementIndex } from './uses/elementIndexUse.js';
import useLocate from './uses/useLocate.js';
// Props
const props = defineProps({
  allArcListMap: {
    type: Object,
    default: () => ({}),
  },
  currentElementIndex: {
    type: Array,
    default: () => [],
  },
  idx: {
    type: Number,
    default: -1,
  },
  parentKeys: {
    type: Array,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: true,
  },
  config: {
    type: Object,
  },
});

// 使用 useElementIndex 来复用 index 逻辑
const { componentName, currentElementIndexStr, itemIdxStr } = useElementIndex(props);

// Expose the props and define necessary reactive state
const activeName = ref(props.config.categoryConfigs[0] ? props.config.categoryConfigs[0].title + 0 : '');

// Computed properties
const edit = computed(() => !props.disabled);

// Watchers
watch(() => props.config.items, () => {
  nextTick(() => {
    activeName.value = props.config.categoryConfigs[0] ? props.config.categoryConfigs[0].title + 0 : '';
  });
}, { deep: true });

// Methods
const getArcListMap = (itemIdx) => {
  const item = props.config.items[itemIdx];
  return item.type === 'articleListItem' ||
    item.type === 'row' ||
    item.type === 'col' ||
    item.type === 'tabsItem' ? props.allArcListMap : undefined;
};

const getTab = () => activeName.value;

const setTab = (i) => {
  const categoryConfig = props.config.categoryConfigs[i];
  if (categoryConfig) {
    activeName.value = categoryConfig.title + i;
  }
};

// Mounted & Unmounted lifecycle hooks
onMounted(() => {
  if (typeof window !== 'undefined') {
    if (!window.pageTabs) {
      window.pageTabs = {};
    }
    window.pageTabs[props.config.id] = {
      setTab,
      getTab,
    };
  }
});

onBeforeUnmount(() => {
  if (typeof window !== 'undefined' && window.pageTabs) {
    delete window.pageTabs[props.config.id];
  }
});


let {
    langJson,
    nowLocale,
    getLocaleText,
} = useLocate()
</script>

<style scoped>
.category-column {
  display: flex;
  align-items: center;
}

.category-item-icon {
  width: 2rem;
  height: 2rem;
}
</style>